import LocalHospital from '@mui/icons-material/LocalHospital'
import RosterItemViewer from 'src/supportPortal/views/roster/component/viewers/RosterItemViewer'

export default function TherapistRosterItemViewer({ ...rest }) {
  return <RosterItemViewer {...rest} sidebarIcon={<LocalHospital />} />
}
